<template>
  <div id="main">
    <div id="main-content">
      <div id="main-header">
        <div id="customer-image-box">
          <img
            id="customer-image-src"
            :src="
              reviewSettingsConfig['customer-image-src']
                ? reviewSettingsConfig['customer-image-src'] +
                  '?cache=' +
                  new Date().getTime()
                : '/images/default-logo.png'
            "
          />
        </div>
        <div id="customer-info-box">
          <h1 id="customer-name">
            {{
              reviewSettingsConfig["customerName"] ||
                account.name ||
                "Company Name"
            }}
          </h1>
          <div id="review-stars">
            <div id="review-star-average">
              {{ reviewSettingsConfig["reviewStarAverage"] || "4.8" }}
            </div>
            <div id="review-star-symbols">
              <div
                id="star-ratings-top"
                :width="(reviewSettingsConfig['star-ratings-top'] || 4.5) + '%'"
              >
                <span>★</span><span>★</span><span>★</span><span>★</span
                ><span>★</span>
              </div>
              <div id="star-ratings-bottom">
                <span>★</span><span>★</span><span>★</span><span>★</span
                ><span>★</span>
              </div>
            </div>
            <div id="review-star-count">
              {{
                (reviewSettingsConfig["reviewStarCount"] || 100) + " reviews"
              }}
            </div>
          </div>
        </div>
      </div>
      <div id="main-body">
        <div id="main-body-content" v-if="showMainBodyContent">
          <h2 class="review-headline">
            {{
              reviewSettingsConfig["reviewHeadline"]
                ? reviewSettingsConfig["reviewHeadline"]
                : ""
            }}
          </h2>
          <div class="review-buttons-container">
            <p class="review-subheadline">
              {{
                reviewSettingsConfig["reviewSubheadline"]
                  ? reviewSettingsConfig["reviewSubheadline"]
                  : ""
              }}
            </p>
            <button
              id="review-on-google"
              class="review-button"
              v-if="checkService('google')"
              @click.prevent="clickActionButton('google')"
            >
              <div class="review-btn-co-icon-container">
                <span class="review-btn-co-icon review-google-icon"></span>
              </div>
              <div
                id="review-on-google-btn"
                class="review-btn-title"
                :title="
                  reviewSettingsConfig['review-on-google-btn']
                    ? reviewSettingsConfig['review-on-google-btn']
                    : ''
                "
              >
                {{
                  reviewSettingsConfig["reviewOnGoogleBtn"]
                    ? reviewSettingsConfig["reviewOnGoogleBtn"]
                    : ""
                }}
              </div>
            </button>
            <button
              id="review-on-facebook"
              class="review-button"
              v-if="checkService('facebook')"
              @click.prevent="clickActionButton('facebook')"
            >
              <div class="review-btn-co-icon-container">
                <span class="review-btn-co-icon review-fb-icon"></span>
              </div>
              <div
                id="review-on-facebook-btn"
                class="review-btn-title"
                :title="
                  reviewSettingsConfig['review-on-facebook-btn']
                    ? reviewSettingsConfig['review-on-facebook-btn']
                    : ''
                "
              >
                {{
                  reviewSettingsConfig["reviewOnFacebookBtn"]
                    ? reviewSettingsConfig["reviewOnFacebookBtn"]
                    : ""
                }}
              </div>
            </button>
          </div>
          <div
            id="review-on-yelp"
            class="review-buttons-container"
            v-if="checkService('yelp')"
          >
            <p id="review-subheadline-yelp">
              {{
                reviewSettingsConfig["reviewSubheadlineYelp"]
                  ? reviewSettingsConfig["reviewSubheadlineYelp"]
                  : ""
              }}
            </p>
            <button
              class="review-button yelp-button"
              @click.prevent="clickActionButton('yelp')"
            >
              <div class="review-btn-co-icon-container">
                <span class="review-btn-co-icon review-yelp-icon"></span>
              </div>
              <div
                id="see-on-yelp-btn"
                class="review-btn-title"
                :title="
                  reviewSettingsConfig['see-on-yelp-btn']
                    ? reviewSettingsConfig['see-on-yelp-btn']
                    : ''
                "
              >
                {{
                  reviewSettingsConfig["seeOnYelpBtn"]
                    ? reviewSettingsConfig["seeOnYelpBtn"]
                    : ""
                }}
              </div>
            </button>
          </div>
          <div id="review-contact-us-container" v-if="checkService('contact')">
            <div id="review-contact-message">
              {{
                reviewSettingsConfig["reviewContactMessage"]
                  ? reviewSettingsConfig["reviewContactMessage"]
                  : ""
              }}
            </div>
            <div>
              <button
                class="contact-button"
                @click.prevent="clickActionButton('contact')"
              >
                <div
                  id="contact-us-feedback-btn"
                  class="contact-btn-title"
                  :title="
                    reviewSettingsConfig['contactUsFeedbackBtn']
                      ? reviewSettingsConfig['contactUsFeedbackBtn']
                      : ''
                  "
                >
                  {{
                    reviewSettingsConfig["contactUsFeedbackBtn"]
                      ? reviewSettingsConfig["contactUsFeedbackBtn"]
                      : ""
                  }}
                </div>
              </button>
            </div>
          </div>
        </div>
        <div id="feedback-form" v-if="showFeedbackFormContent">
          <h2 class="review-headline">
            {{
              reviewSettingsConfig["contactUsHeadline"]
                ? reviewSettingsConfig["contactUsHeadline"]
                : ""
            }}
          </h2>
          <p class="review-subheadline">
            {{
              reviewSettingsConfig["contactUsSubheadline"]
                ? reviewSettingsConfig["contactUsSubheadline"]
                : ""
            }}
          </p>
          <textarea
            class="textarea-form"
            id="feedback-form-textarea"
            rows="6"
          ></textarea>
          <div>
            <button
              id="feedback-submit-button"
              class="feedback-button"
              @click.prevent="clickActionButton('SubmitFeedback')"
            >
              <div class="submit-feedback-btn-title">Submit</div>
            </button>
          </div>
        </div>
        <div id="feedback-thankyou" v-if="showFeedbackThankYouContent">
          <h2 class="review-headline">
            {{
              reviewSettingsConfig["feedbackConfirmationHeadline"]
                ? reviewSettingsConfig["feedbackConfirmationHeadline"]
                : ""
            }}
          </h2>
          <p class="review-subheadline">
            {{
              reviewSettingsConfig["feedbackConfirmationSubheadline"]
                ? reviewSettingsConfig["feedbackConfirmationSubheadline"]
                : ""
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewFeedbackPreview",
  components: {},
  props: {
    pageName: String
  },
  data: function() {
    return {
      hoverCheck: {},
      // serviceFeedbackOptions: ["Google", "Facebook", "Yelp", "Contact"],
      serviceSelected: "",
      rules: {
        required: value => !!value || "Required"
      }
    };
  },
  created() {
    this.$store.dispatch("entities/bizReviewSettings/hydrate", 0);
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    reviewSettings() {
      return this.$store.getters["entities/bizReviewSettings"]().first();
    },
    reviewSettingsConfig() {
      const tempSettings = this.$store.getters[
        "entities/bizReviewSettings"
      ]().first();
      return tempSettings ? tempSettings.config : {};
    },
    bizReviewTypes() {
      let bizReviewTypes = this.$store.getters[
        "entities/bizReviewTypes/query"
      ]().get();
      return bizReviewTypes;
    },
    serviceFeedbackOptions() {
      return [
        ...this.bizReviewTypes,
        {
          code: "contact",
          name: "Contact"
        }
      ];
    },
    showMainBodyContent() {
      return this.pageName == "" || this.pageName == "request";
    },
    showFeedbackFormContent() {
      return this.pageName == "feedback";
    },
    showFeedbackThankYouContent() {
      return this.pageName == "thanks";
    }
  },
  methods: {
    getServiceUrl(service) {
      if (service == "google") {
        return (
          "https://search.google.com/local/writereview?placeid=" +
          this.reviewSettingsConfig["googlePlaceId"]
        );
      } else if (service == "facebook") {
        return (
          "https://www.facebook.com/" +
          this.reviewSettingsConfig["facebookPageId"] +
          "/reviews/"
        );
      } else if (service == "yelp") {
        return (
          "https://www.yelp.com/biz/" + this.reviewSettingsConfig["yelpPageId"]
        );
      }
      return null;
    },
    clickActionButton(service) {
      if (service == "Contact") {
        this.$parent.$parent.$parent.$parent.$parent.stepperStep = 3;
      } else if (service == "SubmitFeedback") {
        this.$parent.$parent.$parent.$parent.$parent.stepperStep = 4;
      } else if (this.checkService(service)) {
        window.open(this.getServiceUrl(service), "_blank");
      }
    },
    checkService(service) {
      return (
        this.reviewSettingsConfig["buttons"] &&
        this.reviewSettingsConfig["buttons"].indexOf(service) >= 0
      );
    }
  }
};
</script>

<style scoped lang="stylus">
.replace-review-link {
  font-size: 70%;
  background: #ddd;
  padding: .2rem .4rem;
  color: #e83e8c;
  border-radius: .4rem;
}
#page-selector {
  text-align: center;
}
.upload-link {
  float: right;
  font-size: .9rem;
  color: #007bff;
  cursor: pointer;
}
.section-side h2 {
  font-size: 2rem;
  margin: 2rem auto 1.5rem;
  text-align: center;
}
.settings-form-reviews {
  padding: 0 1rem;
}
#main {
  width: 100%;
}
@media screen and (min-width: 480px) {
  #main {
    width: 480px;
    margin: 1rem auto 0;
  }
}
#main-content {
  box-sizing: border-box;
  background: #fff;
  width: 100%;
  height: auto;
}
*, *:before, *:after {
  box-sizing: inherit;
}
#main-header {
  box-sizing: border-box;
  background: #1976d2;
  height: 100%;
  width: 100%;
  padding: 20px 40px;
  display: table;
}
#customer-image-box {
  vertical-align: middle;
  padding-right: 15px;
  width: 60px;
  height: 60px;
  display: table-cell;
}
#customer-image-box img {
  width: 60px;
  height: 60px;
}
#customer-info-box {
  vertical-align: middle;
  display: table-cell;
}
#customer-name {
  color: white;
  font-size: 14px;
  margin: -7px 0 7px;
}
#review-stars {
  display: table;
  white-space: nowrap;
}
#review-star-average {
  font-size: 13px;
  color: #fff;
  display: table-cell;
  padding-right: 7px;
}
#review-star-symbols {
  unicode-bidi: bidi-override;
  color: #68b6f3;
  font-size: 13px;
  height: 13px;
  width: 85px;
  margin: 0 auto;
  position: relative;
  padding: 0;
  text-shadow: 0px 1px 0 #68b6f3;
  display: table-cell;
}
#star-ratings-top {
  top: 0px;
  color: #fff;
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  left: 0;
  overflow: hidden;
}
#star-ratings-bottom {
  top: 0px;
  padding: 0;
  display: block;
  z-index: 0;
}
#review-star-symbols span {
  padding: 0 2px;
}
#review-star-count {
  padding-left: 20px;
  font-size: 12px;
  color: #fff;
  display: table-cell;
}
#main-body {
  box-sizing: border-box;
  padding: 40px 30px 60px;
  background: #fff;
  width: 100%;
}
@media screen and (min-width: 480px) {
  #main-body {
    padding: 40px 40px 60px;
  }
}
#main-body-content {
  background: #fff;
}
.review-headline {
  font-size: 28px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #212121;
  font-family: "Roboto Slab",sans-serif;
}
.review-subheadline, #review-subheadline-yelp {
  text-align: center;
  margin: 25px 0;
  font-size: 16px;
  line-height: normal;
  margin-top: -12px;
  font-weight: 300;
  white-space: pre-line;
}
.review-buttons-container {
  margin-top: 40px;
}
button.review-button, button.contact-button, button.feedback-button {
  cursor: pointer;
  width: 280px;
  margin: 10px auto 0;
  height: 52px;
  padding: 2px;
  font-size: 18px;
  font-weight: 400;
  border: 0;
  text-align: center;
  display: table;
  position: relative;
}
@media screen and (min-width: 480px) {
  button.review-button, button.contact-button, button.feedback-button {
    width: 320px;
  }
}
.review-button {
  color: #fff;
  background: #4caf50;
}
button.yelp-button {
  background: white;
  border: 1px solid #e53935;
  color: #e53935;
}
div.review-btn-co-icon-container {
  display: inline-block;
  width: 44px;
  height: 45px;
  background: #fff;
  display: table-cell;
}
.review-btn-co-icon {
  display: inline-block;
  vertical-align: middle;
  background: #fff;
  padding: 5px;
  width: 50px;
  height: 50px;
  transform: scale(.7);
  margin: -2px;
  background-image: url(https://app.dabaone.com/images/service-logos.png);
  background-repeat: no-repeat;
}
.review-google-icon {
  background-position: -60px 5px;
}
.review-fb-icon {
  background-position: 5px 5px;
}
.review-yelp-icon {
  background-position: -125px 5px;
}
.review-btn-title {
  display: table-cell;
  width: 100%;
  vertical-align: middle;
  text-align: center;
}
#review-contact-us-container {
  margin: 30px 0 0;
  font-weight: lighter;
}
#review-contact-message {
  color: #212121;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
}
.contact-button {
  color: #fff;
  background: #e53935;
}
#contact-btn-title {
  margin: 0 auto;
}
#review-footer {
  margin: 20px auto;
  color: #999;
  font-size: 12px;
  text-align: center;
  width: 100%;
  padding-bottom: 40px;
}
.review-footer-message {
  font-size: 11px;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: -.1px;
  color: #999;
  padding-bottom: 10px;
}
.review-footer-message a {
  color: #999;
  text-decoration: none;
}


.textarea-form {
  overflow: auto;
  resize: vertical;
  display: block;
  width: 100%;
  height: 16rem;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
#feedback-form div {
  overflow: hidden;
}
#feedback-submit-button {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  margin-top: 1.5rem;
  width: 100%;
}
</style>
